import React from "react";
import "@/index.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AuthProvider } from "@/contexts/AuthContext";
import { ThemeProvider } from "@/contexts/ThemeContext";
import { Toaster } from "@/components/ui/sonner";
import ProtectedRoute from "@/components/ProtectedRoute";
import ScrollToTop from "@/components/ScrollToTop";

import Landing from "@/pages/Landing";
import PublicAssetPage from "@/pages/PublicAssetPage";
import Login from "@/pages/Login";
import Register from "@/pages/Register";
import Verify from "@/pages/Verify";
import MemberDashboard from "@/pages/MemberDashboard";
import AdminDashboard from "@/pages/AdminDashboard";
import InsurancePage from "@/pages/InsurancePage";
import District from "@/pages/District";
import Knowledge from "@/pages/Knowledge";
import Events from "@/pages/Events";
import HelpDesk from "@/pages/HelpDesk";
import Directory from "@/pages/Directory";
import Gallery from "@/pages/Gallery";
import Terms from "@/pages/Terms";
import Privacy from "@/pages/Privacy";
import Refund from "@/pages/Refund";
import AuthCallback from "@/pages/AuthCallback";

// Detect Emergent Google Auth callback hash synchronously during render.
// REMINDER: DO NOT HARDCODE THE URL, OR ADD ANY FALLBACKS OR REDIRECT URLS, THIS BREAKS THE AUTH
function AppRouter() {
  const location = useLocation();
  if (location.hash?.includes("session_id=")) {
    return <AuthCallback />;
  }
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route path="/" element={<Landing />} />
        <Route path="/login" element={<Login />} />
        <Route path="/register" element={<Register />} />
        <Route path="/verify/:membershipId" element={<Verify />} />
        <Route path="/hardware/:asset_id" element={<PublicAssetPage />} />
        <Route path="/district/:slug" element={<District />} />
        <Route path="/knowledge" element={<Knowledge />} />
        <Route path="/events" element={<Events />} />
        <Route path="/helpdesk" element={<HelpDesk />} />
        <Route path="/directory" element={<Directory />} />
        <Route path="/gallery" element={<Gallery />} />
        <Route path="/terms" element={<Terms />} />
        <Route path="/privacy" element={<Privacy />} />
        <Route path="/refund" element={<Refund />} />
        <Route path="/dashboard" element={
          <ProtectedRoute><MemberDashboard /></ProtectedRoute>
        } />
        <Route path="/insurance" element={
          <ProtectedRoute><InsurancePage /></ProtectedRoute>
        } />
        <Route path="/admin" element={
          <ProtectedRoute role="admin"><AdminDashboard /></ProtectedRoute>
        } />
      </Routes>
    </>
  );
}

function App() {
  return (
    <ThemeProvider>
      <AuthProvider>
        <BrowserRouter>
          <AppRouter />
          <Toaster richColors position="top-right" />
        </BrowserRouter>
      </AuthProvider>
    </ThemeProvider>
  );
}

export default App;
